// Updated Perpus Component with Project Ulang 2
import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  IconButton,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download } from "@mui/icons-material";
import { useState, useEffect } from "react";
import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: { fontSize: 14 },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
  "&:last-child td, &:last-child th": { border: 0 },
}));

function Komputer() {

  const url_list1 = Config.api_domain + "/komputer/active/";
  const [list1, setList1] = useState([]);

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const res = await fetch(url_list1, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList1(data.data || []);
      } catch (error) {
        console.error("Fetch error komputer:", error.message);
      }
    };
    fetchData1();
  }, [url_list1]);

  // PERPUS ULANG 2 (perpus2)
  const url_list2 = Config.api_domain + "/komputer/active/";
  const [list2, setList2] = useState([]);

  useEffect(() => {
    const fetchData2 = async () => {
      try {
        const res = await fetch(url_list2, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList2(data.data || []);
      } catch (error) {
        console.error("Fetch error komputer:", error.message);
      }
    };
    fetchData2();
  }, [url_list2]);

  // PERPUS
  const url_list = Config.api_domain + "/komputer/active/";
  const [list, setList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };
    fetchData();
  }, [url_list]);

  function renderRows(listData, type) {
    if (!listData || listData.length === 0) {
      return (
        <StyledTableRow>
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }

    return listData.map((row, index) => {
      const dateISO = new Date(row.time_uploaded);
      const formatted_datetime = dateToStringDate(dateISO);

      return (
        <StyledTableRow key={row.public_id}>
          <StyledTableCell>{index + 1}</StyledTableCell>
          <StyledTableCell>{row.title}</StyledTableCell>
          <StyledTableCell>{formatted_datetime}</StyledTableCell>
          <StyledTableCell>
            <IconButton
              aria-label="download"
              component="a"
              href={`${Config.api_domain}/${type}/download/${row.public_id}`}
              download
            >
              <Download />
            </IconButton>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>
        <h2>Paket Pengadaan Laptop Media Pembelajaran</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
PPKIG memiliki tanggung jawab strategis dalam memastikan peningkatan kapasitas sumber daya manusia di bidang informasi geospasial. Peran ini semakin penting mengingat pesatnya perkembangan teknologi geospasial yang telah menjadi tulang punggung dalam berbagai sektor, seperti perencanaan wilayah. Peningkatan kompetensi sumber daya manusia dalam bidang ini tidak hanya bertujuan untuk memenuhi kebutuhan teknis saat ini, tetapi juga mempersiapkan tenaga ahli yang mampu beradaptasi dengan perkembangan teknologi di masa depan. Oleh karena itu, PPKIG berupaya menyediakan program pelatihan yang dirancang secara khusus untuk menjawab tantangan yang ada.
<br /><br />
Untuk menjamin suatu program pelatihan mudah dipahami dan menciptakan pengalaman belajar yang lebih efektif dan menarik serta mendorong tercapainya tujuan pelatihan atau pembelajaran, maka sangat penting untuk melengkapi suatu program pelatihan dengan peralatan PC, laptop, dan multimedia. Multimedia yang mencakup elemen visual, audio, video, animasi, dan simulasi interaktif berperan penting dalam menjembatani pemahaman peserta terhadap materi yang kompleks atau bersifat teknis. Penyampaian melalui multimedia membantu memperjelas konsep, meningkatkan keterlibatan peserta, serta memperkuat daya serap dan retensi informasi. Hal ini sangat krusial dalam pelatihan yang membutuhkan visualisasi proses, penggunaan perangkat lunak, atau pemahaman data geospasial.
<br /><br />
Selama ini, pelaksanaan kegiatan pembelajaran dan pelatihan masih menghadapi keterbatasan dalam sarana perangkat komputer/laptop, terutama untuk menunjang kegiatan pengembangan media ajar, demonstrasi aplikasi, serta pembelajaran berbasis Learning Management System (LMS). Laptop yang ada saat ini sebagian sudah berusia lama, memiliki spesifikasi rendah, dan tidak lagi optimal untuk menjalankan aplikasi multimedia maupun perangkat lunak pembelajaran terkini.
<br /><br />
Oleh karena itu, diperlukan pengadaan laptop baru dengan spesifikasi yang sesuai untuk mendukung:
</p>

<ul style={{ textAlign: "justify" }}>
  <li>Penyusunan dan penyajian materi pelatihan berbasis digital;</li>
  <li>Pelaksanaan pembelajaran interaktif dengan software pendukung (SIG, multimedia, e-learning);</li>
  <li>Operasional kegiatan administrasi pembelajaran serta dokumentasi hasil kegiatan;</li>
  <li>Mobilitas tinggi bagi pengajar dan pengelola pelatihan di dalam maupun luar.</li>
</ul>
        {/* ORIGINAL (NON-ULANG) */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderRows(list, "komputer")}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pengumuman RFQ pada website ILASP</StyledTableCell>
                <StyledTableCell>28 November 2025</StyledTableCell>
                <StyledTableCell>4 Desember 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Pemasukan Penawaran</StyledTableCell>
                <StyledTableCell>28 November 2025, 08:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>4 Desember 2025, 16:00 (GMT+7)</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award</StyledTableCell>
                <StyledTableCell>12 Desember 2025</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Award of Contract and Publication of Contract Award</StyledTableCell>
                <StyledTableCell>15 Desember 2025</StyledTableCell>
                <StyledTableCell>15 Desember 2025</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
}

export default Komputer;
